module.exports = __webpack_public_path__ + "img/Wechselladerfahrzeug.97473a28.svg";